import {decorate, observable, action} from "mobx"

export class PoiStore {
  poiData = []

  businessName = ""

  poiId = null

  generateAddressAndStatus(data) {
    if (data) {
      let poiObj = {}
      poiObj["id"] = data["id"]
      poiObj["name"] = data["name"]
      let address = data["address"] ? data["address"] + ", " : ""
      let city = data["city"] ? data["city"] + ", " : ""
      let state = data["state"] ? data["state"] + " " : ""
      let zip = data["zip"] ? data["zip"] : ""
      poiObj["address"] = address + city + state + zip
      data.status && (poiObj["status"] = data["status"])
      data.latitude && (poiObj["latitude"] = data["latitude"])
      data.longitude && (poiObj["longitude"] = data["longitude"])
      return poiObj
    }
  }

  setPoiData(data) {
    if (data) {
      let poiObj = this.generateAddressAndStatus(data)
      this.pushPoiObj(poiObj)
      localStorage.setItem("poi", JSON.stringify(poiObj))
    }
  }

  pushPoiObj(obj) {
    this.poiData.pop()
    this.poiData.push(obj)
  }

  setBusinessName(name) {
    this.businessName = name
  }

  setMapGeoObj(obj) {
    this.mapGeoObj = obj
  }

  setPoiId(id) {
    this.poiId = id
  }
}

decorate(PoiStore, {
  poiData: observable,
  setPoiData: action,

  businessName: observable,
  setBusinessName: action,

  generateAddressAndStatus: action,
  pushPoiObj: action,

  poiId: observable,
  setPoiId: action,
})
